import "../Styles/Admin.css";
import React, { useState } from "react";
import { Button, Form, Input, message } from "antd";
import Logo from "../image/logo192.png";
import { MailOutlined, LockOutlined, LoginOutlined } from "@ant-design/icons";
const Admin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = () => {
    if (username.trim() === "rozhdyar" && password.trim() === "12345rozh") {
      const sessionToken = "example_session_token";
      localStorage.setItem("sessionToken", sessionToken);
      window.location.href = "/";
    } else {
      alert("Invalid credentials. Please try again :(");
    }
  };

  const onFinish = (values) => {
    // console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
    message.error("Error");
  };

  return (
    <div className="login-container">
      {/* Add the header image */}

      <div className="login-header">
        <img src={Logo} alt="Login Header" className="header-image" />
      </div>
      <div className="login-form-container">
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          className="login-form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            name={"username"}
            label={<span className="form-label">username</span>}
            rules={[
              {
                type: "text",
                required: true,
                message: "Email is invalid",
              },
            ]}
          >
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              prefix={<MailOutlined />}
            />
          </Form.Item>

          <Form.Item
            label={<span className="form-label">Password</span>}
            name="password"
            rules={[
              {
                required: true,
                message: "Password is invalid",
              },
            ]}
          >
            <Input.Password
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              prefix={<LockOutlined />}
            />
          </Form.Item>

          <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              icon={<LoginOutlined />}
              onClick={handleLogin}
              style={{ width: "70%" }} // Optional: Adjust button width
            >
              Login
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Admin;
